<div class="d-flex signal-bar">
    <div *ngFor="let count of randomArray(); let i = index" 
        class="square d-flex" 
        [ngStyle]="{'background-color': i < level ? background_color : '#b1b1b1'}">
    </div>
    <span class="text d-flex" *ngIf="strength">{{strength}} dBm</span>
    <span class="badge badge-pill ml-auto" [ngStyle]="{'background-color': background_color}" *ngIf="comment">{{comment}}</span>
</div>